import React from 'react'
import bg2 from '../imgs/Steadywhenwalking.jpg';
import bg3 from '../imgs/dia-diem-du-lich-he-7.jpeg';
import mind from '../imgs/mind&body.png';
import Personal from '../imgs/Personal.png';
import sleep from '../imgs/sleep.png';
import spr from '../imgs/spr.png';
import per from '../imgs/per.png';
import rel from '../imgs/rel.png';
import env from '../imgs/env.png';
import nutri from '../imgs/nutri.png';
import move from '../imgs/move.png';
import cus from '../imgs/cus.png';
const DESTOP_OUTPRODUCT = () => {
  return (
    <section className="relative  text-white py-20 overflow-hidden z-20 h-[843px] hidden md:block">
    {/* Background image layer – z-0 */}
    <div className="absolute inset-0 z-[-1]">
      <img
        src={bg2}
        alt="background"
        className="w-full h-full object-cover"
      />
    </div>

    {/* Gradient overlay – z-10 */}
    <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#0B1D26] via-[#0B1D26]/70 to-[#0B1D26]/0" />

    <div className="absolute inset-0 z-0 bg-gradient-to-t from-[#0B1D26] via-[#0B1D26]/30 to-transparent" />
    {/* Title */}
    <div className="relative h-[40px] flex items-center mb-4 w-full mt-[20px]  " style={{ marginLeft: 70 }}>
      {/* Chữ mờ lớn phía sau */}
      <h2 className="absolute text-[90px] font-bold text-white/5 uppercase leading-none z-10 select-none">
        OUT PRODUCTS
      </h2>

      {/* Chữ nhỏ phía trước */}
      <div className="relative z-10 flex items-center space-x-3">
        <div className="w-[30px] h-0.5 bg-yellow-400"></div>
        <h3 className="text-yellow-400 uppercase tracking-widest text-[22px] font-semibold">
          OUT PRODUCTS
        </h3>
      </div>
    </div>

    {/* Content */}
    <div className="relative z-10 max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center lg:items-start gap-16">
      {/* Left Icons Area */}
      <div className="relative w-full lg:w-1/2 h-[500px] flex items-center top-[40px] justify-center">
        {/* Center Circle */}
        <div className="absolute z-10  rounded-full flex items-center justify-center text-sm font-semibold text-yellow-400 hover:scale-105 transition-transform duration-300">
          <img src={cus} alt="custom" className="w-[145px] h-[145px] mb-6" />
        </div>

        {/* Icons Around */}
        <div className="absolute w-full h-full">
          {/* 12h - Top center */}
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 flex flex-col items-center hover:scale-105 transition-transform duration-300">
            <img src={mind} alt="mind" className="mb-6 w-[75px] h-[80px]" />
          </div>

          {/* 1:30h - Top right */}
          <div className="absolute top-[50px] right-[10%] flex flex-col items-center hover:scale-105 transition-transform duration-300">
            <img src={Personal} alt="personal" className="w-[137px] h-[78px] mb-6" />
          </div>

          {/* 3h - Middle right */}
          <div className="absolute top-1/2 right-4 transform -translate-y-3/4 flex flex-col items-center hover:scale-105 transition-transform duration-300">
            <img src={sleep} alt="sleep" className="w-[71px] h-[80px] mb-6" />
          </div>

          {/* 4:30h - Bottom right */}
          <div className="absolute bottom-[100px] right-[10%] flex flex-col items-center hover:scale-105 transition-transform duration-300">
            <img src={spr} alt="spr" className="w-[62px] h-[80px] mb-6" />
          </div>

          {/* 6h - Bottom center */}
          <div className="absolute  left-[380px] top-[400px] transform -translate-x-1/2 flex flex-col items-center hover:scale-105 transition-transform duration-300">
            <img src={per} alt="per" className="w-[137px] h-[83px] mb-6" />
          </div>

          {/* 7:30h - Bottom left */}
          <div className="absolute top-[395px] left-[30%] flex flex-col items-center hover:scale-105 transition-transform duration-300">
            <img src={rel} alt="rel" className="w-[71px] h-[81px] mb-6" />
          </div>

          {/* 9h - Middle left */}
          <div className="absolute bottom-[45px] left-7 transform -translate-y-1/2 flex flex-col items-center hover:scale-105 transition-transform duration-300">
            <img src={env} alt="env" className="w-[74px] h-[80px] mb-6" />
          </div>

          {/* 10:30h - Top left */}
          <div className="absolute top-1/2 left-[5%] transform -translate-y-3/4 flex flex-col items-center hover:scale-105 transition-transform duration-300">
            <img src={nutri} alt="nutri" className="w-[52px] h-[83px] mb-6" />
          </div>

          {/* 11:30h - Slightly left of top-center */}
          <div className="absolute top-[50px] left-[15%] flex flex-col items-center hover:scale-105 transition-transform duration-300">
            <img src={move} alt="move" className="w-[64px] h-[83px] mb-6" />
          </div>
        </div>
      </div>

      {/* Right Text */}
      <div className="w-full lg:w-1/2 text-white ">
        <div className="absolute right-[40px] max-w-xl text-white text-justify leading-relaxed top-[40px] animate-fade-in-up">
          <h2 className=" text-5xl font-miller mb-4 leading-snug">
            Clever <br />
            <span className="font-miller">Hospitality Management</span>
          </h2>
          <p className="mb-2 indent-2">
            focuses on designing sanctuaries that reflect and celebrate the natural and cultural environment.
            We encourage investors to opt for building design with non-toxic construction materials,
            native plants and creative touches from local artists.
          </p>
          <p className="mb-10 indent-2">
            We believe a vacation is not only about relaxing at the pools, but also a mind and body experience.
            People are always looking for both mental and physical healings.
            Once they have connected to nature and to their inner self,
            that is what we call an ultimate journey.
          </p>
          <p className="">The journey that we design…</p>
        </div>

      </div>
    </div>
  </section>
  )
}

export default DESTOP_OUTPRODUCT